export default __webpack_public_path__ + "static/media/sports.fa43bd2c.svg";